module.exports = __webpack_public_path__ + "static/media/acceptedConfirmation.d3193f63.svg";